<template>
    <div v-if="password" class="marginT-20">
        <div>
            淘口令：
            <el-tooltip class="item point" effect="dark" content="点击复制" placement="bottom-end">
                <el-tag type="info" class="width-150p marginL-20 point" v-clipboard:copy="' ' + password" v-clipboard:success="() => {$message.success('复制成功')}">{{password}}</el-tag>
            </el-tooltip>
            <el-button class="marginL-20" type="text" v-clipboard:copy="' ' + password" v-clipboard:success="() => {$message.success('复制成功')}">点击复制淘口令</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        password: {
            type: String,
            default: ''
        },
    },
}
</script>

<style lang="scss" scoped>

</style>